import { useEffect } from 'react';

/**
 * SEOHead — legacy per-page metadata setter. Kept as a no-op shim because the
 * prerender script's inline runtime injector (see /app/frontend/prerender.js)
 * is now the single source of truth for all SEO metadata.
 *
 * Why this shim exists:
 *   - Many existing pages still import and render <SEOHead title="..." />
 *     with hardcoded values
 *   - Those hardcoded values are usually STALE relative to seo-routes.js
 *   - Worse, they can RACE with the runtime injector — two competing
 *     canonical / og / title writes on the same page caused Google to flag a
 *     "dynamic canonical conflict" during indexing (P0 SEO bug)
 *
 * What this shim does:
 *   - Renders nothing. Doesn't write any DOM, doesn't fight the injector
 *
 * What to migrate to:
 *   - Add new routes to /app/frontend/seo-routes.js. The runtime injector
 *     reads from there and writes the right metadata for every URL. That's
 *     the only place SEO copy should live.
 */
// Props are intentionally accepted but ignored — existing callers don't need to change.
// eslint-disable-next-line no-unused-vars
const SEOHead = ({ title, description, canonical, image, type, jsonLd }) => {
  // Dev-only: warn if a page tries to manage its own SEO so we can migrate it.
  useEffect(() => {
    if (process.env.NODE_ENV === 'development' && title) {
      // eslint-disable-next-line no-console
      console.warn(
        `[SEOHead] Legacy use detected (title="${title}"). Move this route's metadata into /app/frontend/seo-routes.js so the runtime injector handles it. SEOHead is now a no-op shim.`,
      );
    }
  }, [title]);
  return null;
};

export default SEOHead;
